import BaseResponse from 'base/base.response';
import { AccountResponse } from 'model/account/account.model';
import backendClient from 'api/backendClient';

export const getAcccountDetail = async (): Promise<BaseResponse<AccountResponse>> => {
  try {
    const data = await backendClient.get<AccountResponse>('/api/v1/auth/me');
    return {
      code: 200,
      message: 'Account details retrieved successfully',
      data,
      response_time: new Date().toISOString(),
      errors: [],
      request_id: '',
    };
  } catch (error: any) {
    const status = error?.response?.status || 500;
    const msg = error?.message || 'Failed to fetch account';
    return {
      code: status,
      message: msg,
      data: null as any,
      response_time: new Date().toISOString(),
      errors: [msg],
      request_id: '',
    };
  }
};
